import React, { Fragment } from "react"
import { Icon } from "react-icons-kit"
import { facebook } from "react-icons-kit/fa/facebook"
import { github } from "react-icons-kit/fa/github"
import { graphql, useStaticQuery } from "gatsby"
import { linkedin } from "react-icons-kit/fa/linkedin"

import Container from "../../components/UI/Container"
import Logo from "../../components/UIElements/Logo"
import Text from "../../components/Text"
import FooterWrapper, { SocialList } from "./simpleFooter.style"

const socialLinks = [
  {
    id: 1,
    icon: <Icon icon={linkedin} />,
    name: "linkedin",
    link: "https://www.linkedin.com/company/alpacked",
  },
  {
    id: 2,
    icon: <Icon icon={facebook} />,
    name: "facebook",
    link: "https://www.facebook.com/alpacked",
  },
  {
    id: 3,
    icon: <Icon icon={github} />,
    name: "github",
    link: "https://github.com/Alpacked",
  },
]

const SimpleFooter = () => {
  const data = useStaticQuery(graphql`
    query {
      alpackedJson {
        footerData {
          logo {
            publicURL
          }
        }
      }
    }
  `)

  const { logo } = data.alpackedJson.footerData

  return (
    <Fragment>
      <FooterWrapper>
        <Container width="1340px">
          <Logo
            className="logo-footer"
            href="/"
            logoSrc={logo.publicURL}
            title="Interior"
          />
          <div className="right-col">
            <Text content="© 2022 Alpacked LLC" className="copyright" />
            <SocialList>
              {socialLinks.map(item => (
                <li className={item.name} key={`link-key${item.id}`}>
                  <a
                    aria-label={item.name}
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item.icon}
                  </a>
                </li>
              ))}
            </SocialList>
          </div>
        </Container>
      </FooterWrapper>
    </Fragment>
  )
}

export default SimpleFooter
